export class UpdateRoleRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "permissionGrants",
            "baseName": "permissionGrants",
            "type": "Array<PermissionGrantInput>",
            "format": ""
        },
        {
            "name": "accessConditions",
            "baseName": "accessConditions",
            "type": "Array<AccessCondition>",
            "format": ""
        },
        {
            "name": "restoreDestinationLimits",
            "baseName": "restoreDestinationLimits",
            "type": "RestoreDestinationLimits",
            "format": ""
        },
        {
            "name": "sameSourceAccountRestoreLimits",
            "baseName": "sameSourceAccountRestoreLimits",
            "type": "SameSourceAccountRestoreLimits",
            "format": ""
        },
        {
            "name": "backupPoliciesLimits",
            "baseName": "backupPoliciesLimits",
            "type": "BackupPoliciesLimits",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateRoleRequest.attributeTypeMap;
    }
    constructor() {
    }
}
